export const fsu_valid_email_extensions = [
    'fsu.edu',
    'my.fsu.edu',
    'med.fsu.edu',
    'business.fsu.edu',
    'music.fsu.edu',
    'law\.fsu.edu',
    'arts.fsu.edu',
    'education.fsu.edu',
    'eng.fsu.edu',
    'nursing.fsu.edu',
    'socialwork.fsu.edu',
    'coss.fsu.edu',
    'fcrr.fsu.edu',
    'lib.fsu.edu',
    'admissions.fsu.edu',
    'registrar.fsu.edu',
    'hr.fsu.edu',
    'police.fsu.edu',
    'housing.fsu.edu',
    'studentaffairs.fsu.edu',
    'international.fsu.edu',
    'its.fsu.edu',
    'foundation.fsu.edu',
    'research.fsu.edu',
    'wfsu.org',

    // Add more emails extensions here
];